import { ReactNode } from 'react';
import { color } from 'framer-motion';
import { HugeiconsIcon, IconSvgElement } from '@hugeicons/react';

interface BgIconProps {
  icon?: ReactNode;
  hugeIcon?: IconSvgElement,
  color: 'primary' | 'blue' | 'green' | 'red' | 'black';
}

const BgIcon = ({ icon, color, hugeIcon }: BgIconProps) => {

  const colors = {
    primary: {main: 'bg-primary', hover: 'hover:bg-primary', light: 'bg-primary', text: 'text-slate-900'},
    blue: { main: 'bg-indigo-700', hover: 'hover:bg-indigo-700', light: 'bg-indigo-100', text: 'text-indigo-600' },
    red: { main: 'bg-red-600', hover: 'hover:bg-red-700', light: 'bg-red-100', text: 'text-red-600' },
    green: { main: 'bg-green-700', hover: 'hover:bg-green-700', light: 'bg-green-100', text: 'text-green-600' },
    black: { main: 'bg-gray-900', hover: 'hover:bg-gray-700', light: 'bg-gray-100', text: 'text-gray-800' }
  };

  return (<div
    className={`${colors[color].light} ${colors[color].text} w-8 h-8 rounded-lg flex justify-center items-center p-[6px]`}>
    {icon && icon}
    {hugeIcon &&
      <HugeiconsIcon strokeWidth={2} icon={hugeIcon} />
    }
  </div>);
};
export default BgIcon;
